import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/**
 * Skeleton — purposely subtle. Per Emil: animation here is decorative;
 * keep it slow + unobtrusive (no shimmer race against itself).
 */
export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn(
        'relative overflow-hidden rounded-md bg-muted',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-[skel_1400ms_ease-in-out_infinite] before:bg-gradient-to-r before:from-transparent before:via-foreground/5 before:to-transparent',
        className,
      )}
      {...rest}
    />
  );
}

if (typeof document !== 'undefined' && !document.getElementById('fasto-skel-keyframes')) {
  const style = document.createElement('style');
  style.id = 'fasto-skel-keyframes';
  style.textContent = '@keyframes skel { 100% { transform: translateX(100%); } }';
  document.head.appendChild(style);
}
